module.exports = __webpack_public_path__ + "static/postIt04-91c255d73997508c8da24614104a96dc.svg";